import { render, staticRenderFns } from "./PasswortReset.vue?vue&type=template&id=7724ab00&"
import script from "./PasswortReset.vue?vue&type=script&lang=js&"
export * from "./PasswortReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports